<template>
    <v-container fluid class="px-0 elevation-4 py-0 grey lighten-4">
        <main-app-bar title="Master Induction Programme">
            <template v-slot:buttons>
                <v-btn color="primary" @click="saveCourses" :disabled="!selectedRole || saveLoading" :loading="saveLoading">Save</v-btn>
            </template>
        </main-app-bar>
        <v-container>
            <v-row>
                <v-col cols="auto" class="py-0">
                    <v-autocomplete v-model="selectedRole" :loading="rolesLoading" :disabled="rolesLoading || saveLoading" :items="roles" @change="getCoursesHandler" item-text="value" item-value="id" outlined dense hide-details label="Role"/>
                </v-col>
            </v-row>
        </v-container>
        <v-container class="white py-4 px-0">
            <template v-if="!getLoading">
                <v-form v-show="courses.length" ref="coursesForm">
                    <v-simple-table class="program-table mb-4">
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left" style="width: 130px">
                                    Code
                                </th>
                                <th class="text-left">
                                    Name
                                </th>
                                <th class="text-left">
                                    Category
                                </th>
                                <th class="text-left">
                                    Sub Category
                                </th>
                                <th class="text-left" style="width: 100px"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item) in courses" :key="item.key">
                                <td class="py-2">
                                    <v-text-field v-model.trim="item.code" :disabled="saveLoading" :rules="[rules.required, checkUniq]" outlined background-color="grey lighten-3" dense hide-details/>
                                </td>
                                <td class="py-2">
                                    <v-text-field v-model.trim="item.name" :disabled="saveLoading" :rules="[rules.required]" outlined background-color="grey lighten-3" dense hide-details/>
                                </td>
                                <td class="py-2">
                                    <v-text-field v-model.trim="item.category" :disabled="saveLoading" :rules="[rules.required]" outlined background-color="grey lighten-3" dense hide-details/>
                                </td>
                                <td class="py-2">
                                    <v-text-field v-model.trim="item.subcategory" :disabled="saveLoading" :rules="[rules.required]" outlined background-color="grey lighten-3" dense hide-details/>
                                </td>
                                <td class="text-center py-2">
                                    <v-btn icon @click="removeCourse(item)" :disabled="saveLoading">
                                        <v-icon color="gray">mdi-delete</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-form>
                <div v-if="!courses.length" class="text-center grey--text py-4">No data available</div>
                <div class="d-flex justify-center">
                    <v-btn color="primary" @click="addNewCourse" :disabled="saveLoading || !selectedRole">
                        <v-icon small>$plus</v-icon>
                        Add
                    </v-btn>
                </div>
            </template>
            <div v-else class="py-8 text-center">
                <v-progress-circular width="2" size="28" color="primary" indeterminate/>
            </div>
        </v-container>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true" class="text-center justify-center">
            <div class="text-center flex-grow-1">{{ snackbarText }}</div>
        </v-snackbar>
    </v-container>
</template>

<script>
    import MainAppBar from '@/components/MainAppBar'
    import { mapActions } from 'vuex'
    import validationRules from '@/common/validationRules'

    export default {
        name: 'InductionProgramme',
        components: { MainAppBar },
        data: () => ({
            snackbar: false,
            rules: validationRules,
            snackbarText: '',
            snackbarColor: 'error',
            rolesLoading: false,
            saveLoading: false,
            getLoading: false,
            roles: [],
            selectedRole: null,
            courses: [],
            deletedCourses: []
        }),
        mounted: async function () {
            await this.getRoles()
        },
        methods: {
            ...mapActions(['getCoursesRoles', 'setCourses', 'getCourses', 'deleteCourses']),
            checkUniq: function (value) {
                return this.courses.filter(item => item.code === value).length <= 1 || 'Duplicate code'
            },
            getRoles: async function () {
                try {
                    this.rolesLoading = true
                    const rolesData = await this.getCoursesRoles()
                    this.roles = rolesData.data.roles
                    this.rolesLoading = false
                } catch (e) {
                    this.rolesLoading = false
                }
            },
            addNewCourse () {
                const newCourse = {
                    key: Date.now(),
                    code: '',
                    name: '',
                    category: '',
                    subcategory: ''
                }
                this.courses.push(newCourse)
            },
            removeCourse (deleteItem) {
                if (deleteItem.id) {
                    this.deletedCourses.push(deleteItem.id)
                }
                this.courses = this.courses.filter(item => item.key !== deleteItem.key)
            },
            addKeys (array) {
                array.forEach((item, i) => {
                    item.key = Date.now() + i
                })
                return array
            },
            async getCoursesHandler () {
                this.courses = []
                this.deletedCourses = []
                try {
                    this.getLoading = true
                    const coursesData = await this.getCourses(this.selectedRole)
                    this.courses = this.addKeys(coursesData.data.courses)
                    this.getLoading = false
                } catch (e) {
                    this.getLoading = false
                }
            },
            async saveCourses () {
                if (!this.$refs.coursesForm.validate()) {
                    this.courses.forEach((course) => {
                        const checkUniq = this.courses.filter(filterItem => filterItem.code === course.code)
                        if (checkUniq.length > 1) {
                            this.snackbarColor = 'error'
                            this.snackbarText = 'Duplicate code'
                            this.snackbar = true
                        }
                    })
                    return
                }
                const queryData = {}
                let localCourses = []
                queryData.roleId = this.selectedRole
                localCourses = this.courses.map(item => {
                    const localItem = { ...item }
                    delete localItem.key
                    return localItem
                })
                queryData.courses = localCourses
                try {
                    this.saveLoading = true
                    if (this.deletedCourses.length) {
                        await this.deleteCourses(this.deletedCourses)
                    }
                    queryData.courses.length > 0 && await this.setCourses(queryData)
                    const coursesData = await this.getCourses(this.selectedRole)
                    this.courses = this.addKeys(coursesData.data.courses)
                    this.deletedCourses = []
                    this.saveLoading = false
                    this.snackbarColor = 'success'
                    this.snackbarText = 'Programme is successfully changed'
                    this.snackbar = true
                } catch (e) {
                    this.saveLoading = false
                    this.snackbarColor = 'error'
                    this.snackbarText = e.response.data.errors.Courses[0]
                    this.snackbar = true
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .program-table::v-deep {
        table {
            table-layout: fixed;

            th {
                background: white;
            }
        }
    }
</style>
